"use client";

import Script from "next/script";

const FORM_ID = "cmh2ft4ll003w950rteqda86l";
const SCRIPT_ID = "sweet-stream-lead-form";

export default function LeadCaptureEmbedForm() {
  return (
    <div className="w-full">
      <div data-sweet-stream-form={FORM_ID}></div>
      <Script
        id={SCRIPT_ID}
        src="https://crm.sweetstream.app/embed/lead-form.js"
        strategy="afterInteractive"
        data-sweet-stream-base="https://crm.sweetstream.app"
      />
      {/* <Script
        id={SCRIPT_ID}
        src="http://localhost:8080/embed/lead-form.js"
        strategy="afterInteractive"
        data-sweet-stream-base="http://localhost:8080"
      /> */}
    </div>
  );
}
